// extracted by mini-css-extract-plugin
module.exports = {"contactOptionsContainer":"PeopleCollectionManagementModal_contactOptionsContainer__r4xXu","directMessaging":"PeopleCollectionManagementModal_directMessaging__18_tc"};